import React, {useEffect, useState} from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    ButtonGroup,
    CardMedia,
    Grid,
    TextField,
    Tooltip
} from "@mui/material";
import {withStyles} from "@mui/styles";
import {connect} from "react-redux";
import {selectors as adminSelectors} from "../../../../Ducks/admin";
import {actions as eventsOverviewActions, selectors as eventsOverviewSelectors} from "../../../../Ducks/eventsOverview";
import {actions as contactsActions, selectors as ContactsSelectors} from "../../../../Ducks/contacts";
import {actions as opportunityActions, selectors as opportunitySelectors} from "../../../../Ducks/opportunity";
import {bindActionCreators} from "redux";
import CircularProgress from "@mui/material/CircularProgress";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import LanguageIcon from "@mui/icons-material/Language";
import {
    Check,
    ChevronLeft,
    Clear,
    ExpandMore,
    LinkedIn,
    LowPriority,
    Mail,
    MoveDown,
    PersonRemove,
    Phone,
    PhoneAndroid
} from "@mui/icons-material";
import {useNavigate, useParams} from "react-router-dom";
import moment from "moment";
import {ERP_BASE_URL} from "../../../../API/util";
import profileBlankPhoto from "../../../../Assets/images/profile-blank-photo.svg";
import Swal from "sweetalert2";
import {cloneDeep} from "lodash-es";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import NextPlannedAction from "../Widgets/NextPlannedAction";
import {isEmpty} from "lodash";
import CasePauseModal from "../Modals/CasePauseModal";
import CaseOngoingModal from "../Modals/CaseOngoingModal";
import ParticipantPurchases from "../../../Common/Overview/ParticipantPurchases";
import logo from "../../../../Assets/icons/f5-logo.svg";
import TagHook from "../../../Common/Tag";
import AlertElement from "../../../Common/Alert";
import {checkIfPersonFoodConsiderationHasChanged, validateEmail, validatePhone} from "../../../Utils/validations";
import {LoadingButton} from "@mui/lab";
import {selectors as accountSelectors} from "../../../../Ducks/account";
import TransferMembershipModal from "../../ChangePersonJob/TransferMembershipModal";
import {CURRENT, FUTURE, getUserSettings, UNKNOWN} from "../../../Utils/constants";
import CancelPurchaseModal from "../../ChangePersonJob/CancelPurchaseModal";
import {getPendingPersonGroupChange} from "../../../../API/changePersonGroup";
import {getPendingPersonJobChange} from "../../../../API/changePersonJob";
import FollowUp from "../../../Common/Widgets/FollowUp";
import PersonJobOverview from "../../../Common/Widgets/PersonJobOverview";
import PersonHistory from "../../../Common/Widgets/PersonHistory";
import PersonConfigurationHistoryTooltip from "../../../Common/PersonConfigurationHistoryTooltip";
import EditIcon from "@mui/icons-material/Edit";
import {flattenEmptyKey} from "../../../Utils/stringUtils";
import {createOutboundSender, getPersonChangeGroupVisibility} from "../../../../API/eventsOverview";
import {VerifiedEmailIcon} from "../../../Common/Overview/VerifiedEmailIcon";

const useStyles = (_theme) => ({
    title: {
        display: "flex !important",
        alignItems: "center !important",
    },
    card: {
        display: "flex !important",
        backgroundColor: "#fff !important",
    },
    cardMedia: {
        width: "133px !important",
        height: "133px !important",
        backgroundColor: "#F1F1F1 !important",
        margin: "16px"
    },
    cardContent: {
        flex: 4,
        padding: "16px !important",
    },
    flexVertical: {
        display: "flex",
        alignItems: "center",
    },
    flexCenter: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    inputField: {
        flex: 1,
    },
    fieldSet: {
        display: "flex",
        alignItems: "end",
    },
    flex: {
        display: "flex",
    },
    sendout: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    send: {
        background: "green",
        width: "14px",
        height: "14px",
        marginRight: "5px",
    },
    sent: {
        background: "#2785e6",
        width: "14px",
        height: "14px",
        marginRight: "5px",
        borderStyle: "dashed",
    },
    notsent: {
        width: "14px",
        height: "14px",
        marginRight: "5px",
        borderStyle: "solid",
    },
    noBgDotted: {
        background: "transparent",
        width: "19px",
        height: "19px",
        marginRight: "5px",
        border: "red",
        borderStyle: "solid",
    },
    lightBlueBgDotted: {
        width: "19px",
        height: "19px",
        marginRight: "5px",
        background: "repeating-linear-gradient(45deg, red, red 2px, #5cd7ff 2px, #5cd7ff 8px)",
        borderStyle: "solid",
        borderColor: "red",
    },
    lightBlueBgSolid: {
        background: "#5cd7ff",
        width: "19px",
        height: "19px",
        marginRight: "5px",
        borderStyle: "solid",
        borderColor: "#42d142",
    },
    lightBlueBg: {
        background: "#5cd7ff",
        width: "19px",
        height: "19px",
        marginRight: "5px",
    },
    darkBlueBgSolid: {
        background: "#0047ab",
        width: "19px",
        height: "19px",
        marginRight: "5px",
        borderStyle: "solid",
        borderColor: "#42d142",
    },
    darkBlueBg: {
        background: "#0047ab",
        width: "19px",
        height: "19px",
        marginRight: "5px",
    },
    darkBlueBgDotted: {
        background: "#0047ab",
        width: "19px",
        height: "19px",
        marginRight: "5px",
        borderStyle: "solid",
        borderColor: "red",
    },
    noBgSolid: {
        background: "transparent",
        width: "19px",
        height: "19px",
        marginRight: "5px",
        borderStyle: "solid",
    },
    cyanBgSolid: {
        background: "#FDDA0D",
        width: "19px",
        height: "19px",
        marginRight: "5px",
    },
    cyanBgSolidv2: {
        height: "19px",
        width: "19px",
        borderColor: "red",
        borderStyle: "solid",
        marginRight: "5px",
        background: "repeating-linear-gradient(45deg, red, red 2px, #FDDA0D 2px, #FDDA0D 8px)",
    },
    cyanBgSolidv3: {
        height: "19px",
        width: "19px",
        borderColor: "#42d142",
        borderStyle: "solid",
        marginRight: "5px",
        background: "#FDDA0D",
    },
    cyanBg: {
        background: "#FDDA0D",
        width: "19px",
        height: "19px",
        marginRight: "5px",
    },
    grayBg: {
        background: "#757373",
        width: "19px",
        height: "19px",
        marginRight: "5px",
    },
    purpleBg: {
        background: "purple",
        width: "19px",
        height: "19px",
        marginRight: "5px",
    },
    empty: {
        width: "19px",
        height: "19px",
        marginRight: "5px",
        borderStyle: "solid",
        borderColor: "#cacaca",
    },
    completed: {
        width: "19px",
        height: "19px",
        marginRight: "5px",
        borderStyle: "solid",
        borderColor: "green",
        background: "green",
    },
    changed: {
        width: "19px",
        height: "19px",
        marginRight: "5px",
        borderStyle: "solid",
        borderColor: "red",
        background: "green",
    },
    cancelled: {
        width: "19px",
        height: "19px",
        marginRight: "5px",
        borderStyle: "solid",
        borderColor: "red",
        background: "green",
        position: "relative",

        "&::after": {
            content: '"✕"',
            position: "absolute",
            top: "49%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "red",
            fontSize: "26px",
            lineHeight: 1,
        },
    },
    failed: {
        width: "19px",
        height: "19px",
        marginRight: "5px",
        borderStyle: "solid",
        borderColor: "red",
        background: "red",
    },
    attending: {
        "background": "#68a54d !important",
        "color": "#fff !important",
        "&:hover": {
            background: "#68a54d !important",
        },
    },
    not_attending: {
        "background": "#db6669 !important",
        "color": "#fff !important",
        "&:hover": {
            background: "#db6669 !important",
        },
    },
    unknown: {
        "background": "#7f7f7f !important",
        "color": "#fff !important",
        "&:hover": {
            background: "#7f7f7f !important",
        },
    },
    tentative: {
        "background": "#f9fd01 !important",
        "color": "#000 !important",
        "&:hover": {
            background: "#f9fd01 !important",
        },
    },
    appeared: {
        background: "#2785e6",
        width: "14px",
        height: "14px",
        marginRight: "5px",
        borderStyle: "solid",
    },
    nothing: {
        background: "#2785e6",
        width: "14px",
        height: "14px",
        marginRight: "5px",
    },
    happened: {
        background: "green",
        width: "14px",
        height: "14px",
        marginRight: "5px",
    },
    notHappened: {
        width: "14px",
        height: "14px",
        marginRight: "5px",
        borderStyle: "solid",
    },
    answer: {
        "background": "#1976d2",
        "color": "#fff",
        "&:hover": {
            color: "#000",
        },
    },
    accordionSummary: {
        "& > div": {
            flexDirection: "column",
        },
    },
    historyCount: {
        background: "red",
        borderRadius: "50%",
        color: "#fff",
        fontSize: "12px",
        marginLeft: "5px",
        width: "25px",
        height: "25px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    panel: {
        backgroundColor: "#fff",
        color: "rgba(0, 0, 0, 0.87)",
        transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        borderRadius: "4px",
        boxShadow: "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
        position: "relative",
        overflowAnchor: "none",
        padding: "15px",
    },
    checkbox: {
        width: "15px",
        height: "15px",
        cursor: "pointer",
    },
    personTable: {
        "& > tbody > tr > td": {
            padding: "5px",
            minWidth: "160px",
        },
    },
});

const personColumns = [
    "erp_client_id",
    "region_id",
    "person_token",
    "person_firstname",
    "person_lastname",
    "person_never_contact",
    "person_mobile_number",
    "person_preferences_never_text",
    "person_preferences_limit_calls",
    "person_linkedin_url",
    "person_linkedin_member_id",
    "person_challenges",
    "person_food_considerations",
    "person_special_conditions",
    "person_industry",
    "person_country",
    "person_region",
    "person_language",
    "person_gender",
    "lead_source",
    "lead_target_id",
    "sf_person_id",
    "person_created_at",
    "person_last_update",
    "person_awaiting_sync",
    "person_last_sync",
    "person_flagged_from_salesview",
    "person_preferences_pause_sendouts",
    "mini_profile.mp_location_region",
    "mini_profile.mp_location_country",
    "email_verified_at",
];

const attendingStatus = [
    {
        title: "Attending",
        value: "attending",
    },
    {
        title: "Not Attending",
        value: "not_attending",
    },
    {
        title: "Tentative",
        value: "tentative",
    },
    {
        title: "Unknown",
        value: "unknown",
    },
];

const sendOutEmails = [
    {
        title: "Invitation",
        value: "invitation",
    },
    {
        title: "Calendar",
        value: "calendar",
    },
    {
        title: "Placeholder",
        value: "placeholder",
    },
    {
        title: "Reminder email",
        value: "reminder_email",
    },
    {
        title: "Summary email",
        value: "summary_email",
    },
    {
        title: "Reminder sms",
        value: "reminder_sms",
    },
];

const OutboundOverview = (props) => {
    const {classes, item, name} = props;
    let _class = "",
        _changed = false,
        _text = [];

    if (item === undefined) {
        _class = 'empty';
    } else {
        const mailQueueStatus = item[0]?.mail_queue_status?.toLowerCase();

        if (mailQueueStatus === 'complete') {
            if (item[0]?.mail_queue_status_text === 'cancelled') {
                _class = 'cancelled';
            } else {
                _class = 'completed';
            }
        } else if (mailQueueStatus?.includes('failed')) {
            _class = 'failed';
        }
    }

    // Get content and check for status change
    if (item) {
        item.forEach((element) => {
            if (element.changed) {
                _changed = true;
                _text.push(element.created_at + ": " + element.changed_text);

                if (element?.changed_by && element?.changed_by !== '') {
                    _text.push(element?.changed_by);
                }
            }

            _text.push(element.mail_queue_attempted_send + ": " + (element?.mail_queue_status_text || element.mail_queue_status));
        });
    }

    if (item === undefined) {
        return (
            <Tooltip title={name}>
                <div className={classes[_class]}></div>
            </Tooltip>
        );
    } else {
        return (
            <Tooltip
                title={
                    <React.Fragment>
                        <div>{name}</div>
                        <div>
                            {_text.map((text) => (
                                <div>{text}</div>
                            ))}
                        </div>
                    </React.Fragment>
                }
            >
                <div style={_changed ? {border: "1px solid red"} : {border: "none"}} className={classes[_class]}></div>
            </Tooltip>
        );
    }
};

const PersonOverviewTab = (props) => {
    const {
        classes,
        person,
        eventInfo,
        updateAttendanceStatus,
        getContactDetails,
        contactDetails,
        getJobs,
        jobs,
        getPersonPurchases,
        personPurchases,
        getPersonOpportunities,
        personOpportunities,
        getParticipantDetails,
        participantDetails,
        personHistory,
        foodConsiderations,
        isNetworkDirector,
        getPersonOpenOpportunity,
        personOpenOpportunity,
        handleTabChange,
        toggleSpecialCaseTab,
        events,
        opportunity,
        getOpportunityDetails,
        plannedAction,
        opportunityLoading,
        getCalendarLoading,
        updateContactLoading,
        navigate,
        canManageGroupChange,
        canCancelPurchase,
        canTransferMembership,
        transferMembershipEnabled,
        updateAttendanceVerification,
        updateOverviewType,
        updateJobPhone,
        updateJobPhone_loading,
        updatePrimaryJobEmail,
        updatePrimaryJobEmailError
    } = props;
    const {user} = getUserSettings();
    const [personObj, setPersonObj] = React.useState({});
    const [eventDetails, setEventDetails] = React.useState({});
    const [attendeeDetails, setAttendeeDetails] = React.useState(null);
    const [eventOverview, setEventOverview] = React.useState([]);
    const [_outboundOverview, setOutboundOverview] = React.useState(null);
    const [personDetails, setpersonDetails] = React.useState({});
    const [primaryJob, setPrimaryJob] = React.useState(null);
    const [expanded, setExpanded] = React.useState("panel4");
    const [isOpen, setIsOpen] = React.useState(false);
    const [neverContact, setNeverContact] = React.useState(false);
    const [neverSms, setNeverSms] = React.useState(false);
    const [limitCalls, setLimitCalls] = React.useState(false);
    const [limitEmails, setLimitEmails] = React.useState(false);
    const [personChallenges, setPersonChallenges] = React.useState("");
    const [personFoodConsiderations1, setPersonFoodConsiderations1] = React.useState(17);
    const [personFoodConsiderations2, setPersonFoodConsiderations2] = React.useState([18]);
    const [personFoodConsiderationsOther, setPersonFoodConsiderationsOther] = React.useState("");
    const [personPielineStage, setPersonPielineStage] = React.useState("");
    const [personPielineStages, setPersonPielineStages] = React.useState([]);
    const [action, setAction] = React.useState({});
    const [eventModalOpen, setEventModalOpen] = React.useState(false);
    const [openCaseModal, setOpenCaseModal] = React.useState(false);
    const [overviewQuery, setOverviewQuery] = React.useState(null);
    const [personTags, setPersonTags] = React.useState([]);
    const [openTransferMembershipModal, setOpenTransferMembershipModal] = useState(false)
    const [openCancelPurchaseModal, setOpenCancelPurchaseModal] = useState(false)
    const [currentPurchase, setCurrentPurchase] = useState(null);
    const [showChangeJob, setShowChangeJob] = useState(false);
    const [showChangeGroup, setShowChangeGroup] = React.useState(false);
    const [hideChangeGroupByResale, setHideChangeGroupByResale] = useState(false);
    const [pauseSendouts, setPauseSendouts] = React.useState(false);
    const [editMobile, setEditMobile] = React.useState(false);
    const [editEmail, setEditEmail] = React.useState(false);
    const [editPhone, setEditPhone] = React.useState(false);
    const [editJobEmail, setEditJobEmail] = React.useState(false);
    const [mobile, setMobile] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [phone, setPhone] = React.useState('');
    const [phoneError, setPhoneError] = useState(false);
    const [mobileError, setMobileError] = useState(false);
    const [emailError, setEmailError] = useState(false);

    useEffect(() => {
        props.getFoodConsiderations();

        // set query
        const _overviewQuery = getQuery();
        setOverviewQuery(_overviewQuery);
    }, []);

    useEffect(() => {
        if (person !== null && person !== undefined) {
            setPersonObj(person);
            getContactDetails({id: person.person_id, columns: personColumns});
            getJobs(person.person_id);
            getPersonOpenOpportunity(person.person_id);
            getPersonPurchases(person.person_id);
            getPersonOpportunities(person.person_id);
            getChangePersonGroup(person.person_id);
            getChangePersonJob(person.person_id);
            checkChangeGroupVisibility(person.person_id);
        }

        if (eventInfo !== null && eventInfo !== undefined) {
            setEventDetails(eventInfo);
        }

        if (person !== null && person !== undefined && eventInfo !== null && eventInfo !== undefined) {
            getParticipantDetails({event_id: eventInfo.event_id, participant_id: person.potential_participant_id});
        }
    }, [person, eventInfo]);

    useEffect(() => {
        if (contactDetails !== null && contactDetails !== undefined) {
            let person = contactDetails.main[0];
            let miniProfile = flattenEmptyKey(contactDetails.related_objects.mini_profile);
            setpersonDetails({...person, ...miniProfile});
            setMobile(contactDetails.main[0].person_mobile_number);
            // set checkboxes
            setNeverContact(contactDetails.main[0].person_never_contact);
            setNeverSms(contactDetails.main[0].person_preferences_never_text);
            setLimitCalls(contactDetails.main[0].person_preferences_limit_calls);
            setLimitEmails(contactDetails.main[0].person_preferences_limit_emails);
            setPauseSendouts(contactDetails.main[0].person_preferences_pause_sendouts);


            // set fields
            setPersonChallenges(contactDetails.main[0].person_challenges);

            setPersonFoodConsiderations1(
                (contactDetails.main[0].person_food_considerations_1 && contactDetails.main[0].person_food_considerations_1 !== '')
                    ? contactDetails.main[0].person_food_considerations_1 : "17"
            );
            setPersonFoodConsiderations2(
                (contactDetails.main[0].person_food_considerations_2 && contactDetails.main[0].person_food_considerations_2?.length > 0)
                    ? contactDetails.main[0].person_food_considerations_2 : [18]
            );
            setPersonFoodConsiderationsOther(
                (contactDetails.main[0].person_food_considerations_other && contactDetails.main[0].person_food_considerations_other !== '')
                    ? contactDetails.main[0].person_food_considerations_other : ""
            );
            contactDetails && getChangePersonGroup(contactDetails.main[0].person_id);

        }
    }, [contactDetails]);

    useEffect(() => {
        let _primaryJob = jobs?.main.filter((item) => item.job_is_primary === 1);

        if (_primaryJob?.length > 0) {
            setPrimaryJob(_primaryJob[0]);
            setPhone(_primaryJob[0].job_phone);
            setEmail(_primaryJob[0].job_email);
        }
    }, [jobs]);

    useEffect(() => {
        if (participantDetails) {
            const _eventOverview = cloneDeep(participantDetails.event_overview);
            if (_eventOverview) {
                // Sort
                _eventOverview.sort(function (a, b) {
                    return new Date(a.event_start) - new Date(b.event_start);
                });
                setEventOverview(_eventOverview);
                setOutboundOverview(participantDetails.outbound_overview);
                setAttendeeDetails(participantDetails);
            }
        }
    }, [participantDetails]);

    useEffect(() => {
        if (personOpenOpportunity) {
            if (personOpenOpportunity.opportunity_id) {
                getOpportunityDetails({id: personOpenOpportunity.opportunity_id, preloadNextPrevOpportunity: false});
            }

            setPersonPielineStage(personOpenOpportunity.pipeline_stage_id ? personOpenOpportunity.pipeline_stage_id : "");
            setPersonPielineStages(personOpenOpportunity.pipeline_stages ? personOpenOpportunity.pipeline_stages : []);
            setAction(personOpenOpportunity.opportunity_actions || {});
        }
    }, [personOpenOpportunity]);

    useEffect(() => {
        if (personPurchases) {
            const _currentPurchase = personPurchases.find(purchase => purchase.purchase_actual_status === CURRENT);
            const _futurePurchase = personPurchases.find(purchase => purchase.purchase_actual_status === FUTURE);
            let _activePurchase = _currentPurchase;

            setCurrentPurchase(null);

            if (_currentPurchase) {
                setCurrentPurchase(_currentPurchase);
            } else {
                if (_futurePurchase) {
                    setCurrentPurchase(_futurePurchase);
                }
            }

            if (_activePurchase?.opportunity_id === personOpenOpportunity?.opportunity_id && personOpenOpportunity?.opportunity_status === 'open') {
                setShowChangeGroup(false);
            }
        }
    }, [personPurchases, showChangeGroup]);

    useEffect(() => {
        if (updatePrimaryJobEmailError?.message && primaryJob) {
            setEmail(primaryJob?.job_email);
        }
    }, [updatePrimaryJobEmailError]);


    const showProgress = () => (
        <div style={{display: "flex", justifyContent: "center"}}>
            <CircularProgress/>
        </div>
    );

    const attendanceStatusUpdate = (item) => {
        if (item.value === participantDetails.answer.value) {
            if (participantDetails.attendance_verified !== 1
                && participantDetails.answer.value !== UNKNOWN.toLowerCase()
                && (user.user_details.member_service_agent ||
                    user.user_details.resale_sales_rep)) {
                // if already selected attendance status button clicked, and the logged-in user either member service agent
                // or the resale user on any product/event then send verify attendance request to server.
                attendanceVerificationUpdate();
            }
        } else {
            const data = {
                participantDetails: {event_id: eventInfo.event_id, participant_id: person.potential_participant_id},
                query: overviewQuery,
                obj: {
                    event_id: eventDetails.event_id,
                    job_id: personObj.job_id,
                    attending: item.value,
                },
                updateOverviewType: updateOverviewType
            };
            updateAttendanceStatus(data);
            setAttendeeDetails(null);
        }
    };

    const getQuery = () => {
        const {query} = props;
        const start_date = moment(query.range[0]).format("YYYY-MM-DD");
        const end_date = moment(query.range[1]).format("YYYY-MM-DD");
        let _query = `equals[event_start_date]=${start_date}&equals[event_end_date]=${end_date}`;
        if (query.productType !== "" && query.productType !== null) {
            _query = `${_query}&equals[product_type_id]=${query.productType.product_type_id}`;
        }
        if (query.product !== "" && query.product !== null && query.product !== undefined) {
            _query = `${_query}&equals[product_id]=${query.product.product_id}`;
        }
        if (query.user !== "" && query.user !== null && query.user !== undefined) {
            _query = `${_query}&equals[user_id]=${query.user.user_id}&equals[user_type]=${query.user.user_type}`;
        }
        if (query.country !== "" && query.country !== null && query.country !== undefined) {
            _query = `${_query}&equals[country_id]=${query.country.country_id}`;
        }
        if (query.networkDirector !== "" && query.networkDirector !== null && query.networkDirector !== undefined) {
            _query = `${_query}&equals[network_directors]=${query.networkDirector.id}`;
        }

        return _query;
    };

    const handleSendoutEmail = (e) => {
        const postData = {
            event_id: eventDetails.event_id,
            data: {
                job_id: personObj.job_id,
                invitation_type: e.target.value,
            },
        };

        createOutboundSender(postData).then((res) => {
            Swal.fire({
                title: "",
                text: res.message,
                icon: res.result ? "success" : "warning",
                showCancelButton: false,
                confirmButtonText: "Ok",
            }).then((_result) => {
            });
        });
    };

    const getStatusClass = (item) => {
        const {event_has_happened, showed, color, has_open_opportunity, purchase_id, freezed, case_status} = item;
        if (freezed && case_status === 'PENDING') {
            return "purpleBg";
        } else if (freezed && case_status === 'APPROVED') {
            return "grayBg"
        } else {
            if (event_has_happened && color === undefined && purchase_id === undefined && showed === undefined) {
                return "noBgDotted";
            } else if (event_has_happened && color === "purchase_a" && !has_open_opportunity && !showed) {
                return "lightBlueBgDotted";
            } else if (event_has_happened && color === "purchase_a" && !has_open_opportunity && showed) {
                return "lightBlueBgSolid";
            } else if (!event_has_happened && color === "purchase_a" && !has_open_opportunity && !showed) {
                return "lightBlueBg";
            } else if (event_has_happened && color === "purchase_b" && !has_open_opportunity && showed) {
                return "darkBlueBgSolid";
            } else if (event_has_happened && color === "purchase_b" && !has_open_opportunity && !showed) {
                return "darkBlueBgDotted";
            } else if (!event_has_happened && color === "purchase_b" && !has_open_opportunity && !showed) {
                return "darkBlueBg";
            } else if (!event_has_happened && color === undefined && purchase_id === undefined && showed === undefined) {
                return "noBgSolid";
            } else if (!event_has_happened && color === "purchase_a" && has_open_opportunity && !showed) {
                return "cyanBgSolid";
            } else if (!event_has_happened && color === "purchase_b" && has_open_opportunity && !showed) {
                return "cyanBg";
            } else if (event_has_happened && (color === "purchase_b" || color === "purchase_a") && has_open_opportunity && !showed) {
                return "cyanBgSolidv2";
            } else if (event_has_happened && (color === "purchase_b" || color === "purchase_a") && has_open_opportunity && showed) {
                return "cyanBgSolidv3";
            } else {
                return "noBgSolid";
            }
        }
    };

    if (!person) {
        return showProgress();
    }

    const handleChange = (panel) => (_event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    const handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        if (name === "person_challenges") {
            setPersonChallenges(value);
        }

        if (name === "person_never_contact") {
            setNeverContact(value);
        }

        if (name === "person_preferences_never_text") {
            setNeverSms(value);
        }

        if (name === "person_preferences_limit_calls") {
            setLimitCalls(value);
        }

        if (name === "person_preferences_limit_emails") {
            setLimitEmails(value);
        }

        if (name === "person_preferences_pause_sendouts") {
            setPauseSendouts(value);
        }

        if (name === "tags") {
            setPersonTags(value);
        }
    };

    const saveInfo = () => {
        const personData = {
            id: person.person_id,
            obj: {
                person_challenges: personChallenges,
                person_food_considerations_1: personFoodConsiderations1,
                person_food_considerations_2: personFoodConsiderations2,
                person_food_considerations_other: personFoodConsiderationsOther,
                person_never_contact: neverContact,
                person_preferences_never_text: neverSms,
                person_preferences_limit_calls: limitCalls,
                person_preferences_limit_emails: limitEmails,
                person_preferences_pause_sendouts: pauseSendouts,
                tags: personTags
            },
            columns: personColumns
        }

        const personFoodConsiderationHasChanged =
            checkIfPersonFoodConsiderationHasChanged(personDetails, personData, foodConsiderations, 'event_overview', props);

        if (!personFoodConsiderationHasChanged) {
            props.updateContact(personData);
        }
    };

    const saveMobile = () => {
        const personData = {
            id: person.person_id,
            obj: {
                person_mobile_number: mobile
            },
            columns: personColumns
        }

        props.updateContact(personData);
    }

    const handleTags = (_name, value) => {
        setPersonTags(value);
    }

    const getChangePersonGroup = (personId) => {
        getPendingPersonGroupChange(personId).then((res) => {
            if (res?.data?.person_id) {
                setShowChangeGroup(false);
            } else {
                setShowChangeGroup(true);
            }
        }).catch(() => {
            setShowChangeGroup(true);
        });
    }

    const checkChangeGroupVisibility = (personId) => {
        getPersonChangeGroupVisibility(personId).then((res) => {
            setHideChangeGroupByResale(res?.data?.hide === true);
        }).catch(() => {
            setHideChangeGroupByResale(false);
        });
    };

    const handleChangeGroupClick = () => {
        personDetails && navigate("/contact/id/" + personDetails.person_id + "/change-group");
    };

    const getChangePersonJob = (personId) => {
        getPendingPersonJobChange(personId).then((res) => {
            if (res?.data?.person_id) {
                setShowChangeJob(false);
            } else {
                setShowChangeJob(true);
            }
        }).catch(() => {
            setShowChangeJob(true);
        });
    }

    const handleTransferMembershipClose = (fetchPendingRequest = false) => {
        setOpenTransferMembershipModal(false);

        if (fetchPendingRequest) {
            getChangePersonJob(person.person_id)
        }
    };

    const handleCancelPurchaseClose = (fetchPendingRequest = false) => {
        setOpenCancelPurchaseModal(false);

        if (fetchPendingRequest) {
            getChangePersonJob(person.person_id)
        }
    };

    const attendanceVerificationUpdate = (verify = true) => {
        let postData = {
            participantDetails: {event_id: eventInfo.event_id, participant_id: person.potential_participant_id},
            query: overviewQuery,
            data: {
                potential_participant_id: personObj.potential_participant_id,
                attendance_verified: verify,
            },
            updateOverviewType: updateOverviewType
        }

        if (!verify) {
            updateAttendanceVerification(postData);
        } else {
            Swal.fire({
                title: `Do you want to verify the attendance status?`,
                text: "",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
            }).then((result) => {
                if (result.isConfirmed) {
                    updateAttendanceVerification(postData);
                }
            });
        }
    }

    const handleUpdatePrimaryJobEmailCheck = () => {
        if (email && primaryJob?.job_email !== email) {
            if (validateEmail(email)) {
                let contactData = {
                    jobID: primaryJob.job_id,
                    personId: person.person_id,
                    obj: {job_email: email},
                }

                Swal.fire({
                    title: 'Are you sure?',
                    text: `By confirming, ${person.person_firstname} ${person.person_lastname} 
                    will receive the invitation for all upcoming events at the ${email}.`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Confirm',
                    cancelButtonText: 'Cancel'
                })
                    .then(result => {
                        if (result.isConfirmed) {
                            updatePrimaryJobEmail(contactData)
                        } else {
                            setEmail(primaryJob.job_email);
                        }
                    });

                setEditEmail(false);
                setEmailError(false);
            } else {
                setEmailError(true);
            }
        } else {
            setEditEmail(false);
            setEmail(primaryJob.job_email);
        }
    }

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} sx={{marginBottom: "10px"}}>
                    {
                        personDetails && personDetails.person_food_considerations_set_by_notice !== '' &&
                        <p><AlertElement severity="info"
                                         message={personDetails.person_food_considerations_set_by_notice}/></p>
                    }

                    <Card className={classes.card}>
                        <Grid container>
                            <Grid item sx={{padding: 0, width: "165px"}}>
                                <CardMedia
                                    className={classes.cardMedia}
                                    component="img"
                                    alt="person image"
                                    image={`${ERP_BASE_URL}/uploads/images/persons/${personDetails.person_token}.jpg`}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = profileBlankPhoto;
                                    }}
                                />
                            </Grid>
                            <Grid item sx={{padding: 0, flex: 1}}>
                                <CardContent className={classes.cardContent}>
                                    <Grid container>
                                        <Grid item xs={9}>
                                            <div style={{display: "flex", flexDirection: "column"}}>
                                                <Typography variant='h6' component='div'>
                                                    {personDetails.person_firstname} {personDetails.person_lastname}
                                                </Typography>
                                                {primaryJob?.job_title && (
                                                    <Typography style={{marginBottom: "10px"}} variant='body2'
                                                                color='site.main'>
                                                        <span>{primaryJob?.job_title}</span>
                                                    </Typography>
                                                )}
                                                {personDetails.mp_location_region && (
                                                    <Grid container sx={{margin: '5px 0'}}>
                                                        <Grid item xs={9}>
                                                            <Typography variant='body2' color='site.main'
                                                                        className={classes.flexVertical}>
                                                                <LanguageIcon
                                                                    sx={{color: "icon.main", fontSize: "20px"}}/>
                                                                <span
                                                                    style={{marginLeft: "8px"}}>{personDetails.mp_location_region}</span>
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                )}
                                                <Grid container sx={{marginTop: '5px'}}>
                                                    {
                                                        !editMobile && (
                                                            <>
                                                                <Grid item xs={9}>
                                                                    <Typography variant='body2' color='site.main'
                                                                                className={classes.flexVertical}>
                                                                        <PhoneAndroid sx={{
                                                                            color: "icon.main",
                                                                            fontSize: "20px"
                                                                        }}/>{" "}
                                                                        {
                                                                            personDetails.person_mobile_number ?
                                                                                <a href={`callto:${personDetails.person_mobile_number}`}
                                                                                   style={{
                                                                                       textDecoration: 'none',
                                                                                       color: 'inherit',
                                                                                       display: 'flex',
                                                                                       alignItems: 'center'
                                                                                   }}>
                                                                                    <Tooltip title="Mobile Number"
                                                                                             placement="top">
                                                                            <span style={{marginLeft: '8px'}}>
                                                                                {personDetails.person_mobile_number}
                                                                            </span>
                                                                                    </Tooltip>
                                                                                </a>
                                                                                :
                                                                                <span style={{marginLeft: "8px"}}>Add Mobile Number</span>
                                                                        }

                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={2}>
                                                                    <EditIcon sx={{
                                                                        color: "icon.main",
                                                                        fontSize: '20px',
                                                                        cursor: 'pointer'
                                                                    }} onClick={() => {
                                                                        setEditMobile(true)
                                                                    }}/>
                                                                </Grid>
                                                            </>
                                                        )
                                                    }
                                                    {
                                                        editMobile && (
                                                            <>
                                                                <Grid item xs={12} sx={{
                                                                    display: "flex",
                                                                    flexDirection: "row",
                                                                    alignItems: "center",
                                                                    padding: "10px 0"
                                                                }}>
                                                                    <TextField
                                                                        type="number"
                                                                        id="mobile"
                                                                        label="Mobile"
                                                                        variant="outlined"
                                                                        size="small"
                                                                        value={mobile}
                                                                        sx={{
                                                                            width: "280px",
                                                                            '& .MuiInputBase-root': {
                                                                                height: '2rem',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                lineHeight: '1rem',
                                                                            }
                                                                        }}
                                                                        onChange={(e) => {
                                                                            setMobile(e.target.value);

                                                                            if (e.target.value) {
                                                                                if (validatePhone(e.target.value, personDetails.person_country)) {
                                                                                    setMobileError(false);
                                                                                }
                                                                            } else {
                                                                                setMobileError(false);
                                                                            }
                                                                        }}
                                                                    ></TextField>
                                                                    <Typography variant="body2" color="site.main"
                                                                                sx={{
                                                                                    display: 'flex',
                                                                                    margin: '5px 0 0 5px'
                                                                                }}>
                                                                        <Check sx={{
                                                                            color: 'green',
                                                                            fontSize: "20px",
                                                                            cursor: 'pointer'
                                                                        }} onClick={() => {
                                                                            if (mobile) {
                                                                                if (validatePhone(mobile, personDetails.person_country)) {
                                                                                    saveMobile();
                                                                                    setEditMobile(false);
                                                                                    setMobileError(false);
                                                                                } else {
                                                                                    setMobileError(true);
                                                                                }
                                                                            } else {
                                                                                saveMobile();
                                                                                setEditMobile(false);
                                                                            }
                                                                        }}/>
                                                                        <Clear sx={{
                                                                            color: 'red',
                                                                            fontSize: "20px",
                                                                            cursor: 'pointer'
                                                                        }} onClick={() => {
                                                                            setEditMobile(false);
                                                                            setMobileError(false);
                                                                            setMobile(personDetails.person_mobile_number);
                                                                        }}/>
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    {
                                                                        mobileError &&
                                                                        <span style={{color: 'red', fontSize: '11px'}}>Invalid Mobile Number</span>
                                                                    }
                                                                </Grid>
                                                            </>
                                                        )
                                                    }
                                                </Grid>
                                                <Grid container sx={{marginTop: '5px'}}>
                                                    {
                                                        !editPhone &&
                                                        <>
                                                            <Grid item xs={9}>
                                                                <Typography variant='body2' color='site.main'
                                                                            className={classes.flexVertical}>
                                                                    <Phone
                                                                        sx={{color: "icon.main", fontSize: '20px'}}/>
                                                                    {
                                                                        primaryJob?.job_phone ?
                                                                            <a href={`callto:${primaryJob.job_phone}`}
                                                                               style={{
                                                                                   textDecoration: 'none',
                                                                                   color: 'inherit',
                                                                                   display: 'flex',
                                                                                   alignItems: 'center'
                                                                               }}>
                                                                                <Tooltip title="Direct Number">
                                                                        <span style={{marginLeft: '8px'}}>
                                                                            {primaryJob.job_phone}
                                                                        </span>
                                                                                </Tooltip>
                                                                            </a>
                                                                            :
                                                                            <span style={{marginLeft: '8px'}}>Add direct number</span>
                                                                    }
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                <EditIcon sx={{
                                                                    color: "icon.main",
                                                                    fontSize: '20px',
                                                                    cursor: 'pointer'
                                                                }} onClick={() => {
                                                                    setEditPhone(true)
                                                                }} disabled={updateJobPhone_loading}/>
                                                            </Grid>
                                                        </>
                                                    }
                                                    {
                                                        editPhone &&
                                                        <>
                                                            <Grid item xs={12} sx={{
                                                                display: "flex",
                                                                flexDirection: "row",
                                                                alignItems: "center",
                                                                padding: "10px 0"
                                                            }}>
                                                                <TextField
                                                                    type="number"
                                                                    id="phone"
                                                                    label="Direct Number"
                                                                    variant="outlined"
                                                                    size="small"
                                                                    value={phone}
                                                                    sx={{
                                                                        width: "280px",
                                                                        '& .MuiInputBase-root': {
                                                                            height: '2rem',
                                                                        },
                                                                        '& .MuiInputBase-input': {
                                                                            lineHeight: '1rem',
                                                                        }
                                                                    }}
                                                                    onChange={(e) => {
                                                                        setPhone(e.target.value);

                                                                        if (e.target.value) {
                                                                            if (validatePhone(e.target.value, personDetails.person_country)) {
                                                                                setPhoneError(false);
                                                                            }
                                                                        } else {
                                                                            setPhoneError(false);
                                                                        }
                                                                    }}
                                                                ></TextField>
                                                                <Typography variant="body2" color="site.main"
                                                                            sx={{
                                                                                display: 'flex',
                                                                                margin: '5px 0 0 5px'
                                                                            }}>
                                                                    <Check sx={{
                                                                        color: 'green',
                                                                        fontSize: "20px",
                                                                        cursor: 'pointer'
                                                                    }} onClick={() => {
                                                                        let contactData = {
                                                                            jobID: primaryJob.job_id,
                                                                            obj: {job_phone: phone},
                                                                            personId: person.person_id
                                                                        }

                                                                        if (phone) {
                                                                            if (validatePhone(phone, personDetails.person_country)) {
                                                                                updateJobPhone(contactData);
                                                                                setEditPhone(false);
                                                                                setPhoneError(false);
                                                                            } else {
                                                                                setPhoneError(true);
                                                                            }
                                                                        } else {
                                                                            updateJobPhone(contactData);
                                                                            setEditPhone(false);
                                                                        }
                                                                    }}/>
                                                                    <Clear sx={{
                                                                        color: 'red',
                                                                        fontSize: "20px",
                                                                        cursor: 'pointer'
                                                                    }} onClick={() => {
                                                                        setEditPhone(false);
                                                                        setPhoneError(false);
                                                                        setPhone(primaryJob.job_phone);
                                                                    }}/>
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                {
                                                                    phoneError &&
                                                                    <span style={{color: 'red', fontSize: '11px'}}>Invalid Phone Number</span>
                                                                }
                                                            </Grid>
                                                        </>
                                                    }
                                                </Grid>
                                                <Grid container sx={{marginTop: '5px'}}>
                                                    {
                                                        !editEmail &&
                                                        <>
                                                            <Grid item xs={9}>
                                                                <Typography variant='body2' color='site.main'
                                                                            className={classes.flexVertical}>
                                                                    <Mail sx={{color: "icon.main", fontSize: '20px'}}/>
                                                                    {
                                                                        primaryJob?.job_email ?
                                                                            (
                                                                                <>
                                                                                    <a style={{
                                                                                        textDecoration: 'none',
                                                                                        color: 'inherit',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center'
                                                                                    }}
                                                                                       href={`mailto:${primaryJob.job_email}`}>
                                                                                        <span style={{
                                                                                            marginLeft: '8px',
                                                                                            wordBreak: 'break-all'
                                                                                        }}>
                                                                                            {primaryJob.job_email}
                                                                                        </span>
                                                                                    </a>

                                                                                    <VerifiedEmailIcon person={{
                                                                                        ...personObj,
                                                                                        primary_job_email: primaryJob.job_email
                                                                                    }}/>
                                                                                </>
                                                                            )
                                                                            :
                                                                            <span style={{marginLeft: '8px'}}>
                                                                                Add primary job email
                                                                            </span>
                                                                    }
                                                                </Typography>
                                                            </Grid>
                                                            {
                                                                /** Only a resale manager is able to edit an email address of a contact */
                                                                eventDetails?.user_id === user.user_details.user_id &&
                                                                <Grid item xs={2}>
                                                                    <EditIcon sx={{
                                                                        color: "icon.main",
                                                                        fontSize: '20px',
                                                                        cursor: 'pointer'
                                                                    }}
                                                                              onClick={() => setEditEmail(true)}/>
                                                                </Grid>
                                                            }
                                                        </>
                                                    }
                                                    {
                                                        editEmail &&
                                                        <>
                                                            <Grid item xs={12} sx={{
                                                                display: "flex",
                                                                flexDirection: "row",
                                                                alignItems: "center",
                                                                padding: "10px 0"
                                                            }}>
                                                                <TextField
                                                                    type="email"
                                                                    id="email"
                                                                    label="Primary Job Email"
                                                                    variant="outlined"
                                                                    size="small"
                                                                    value={email}
                                                                    sx={{
                                                                        width: "280px",
                                                                        '& .MuiInputBase-root': {
                                                                            height: '2rem',
                                                                        },
                                                                        '& .MuiInputBase-input': {
                                                                            lineHeight: '1rem',
                                                                        }
                                                                    }}
                                                                    onChange={(e) => {
                                                                        setEmail(e.target.value);

                                                                        if (e.target.value) {
                                                                            if (validateEmail(e.target.value)) {
                                                                                setEmailError(false);
                                                                            }
                                                                        } else {
                                                                            setEmailError(false);
                                                                        }
                                                                    }}
                                                                ></TextField>
                                                                <Typography variant="body2" color="site.main"
                                                                            sx={{
                                                                                display: 'flex',
                                                                                margin: '5px 0 0 5px'
                                                                            }}>
                                                                    <Check sx={{
                                                                        color: 'green',
                                                                        fontSize: "20px",
                                                                        cursor: 'pointer'
                                                                    }} onClick={handleUpdatePrimaryJobEmailCheck}/>
                                                                    <Clear sx={{
                                                                        color: 'red',
                                                                        fontSize: "20px",
                                                                        cursor: 'pointer'
                                                                    }} onClick={() => {
                                                                        setEditEmail(false);
                                                                        setEmailError(false);
                                                                        setEmail(primaryJob.job_email);
                                                                    }}/>
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                {
                                                                    emailError &&
                                                                    <span style={{color: 'red', fontSize: '11px'}}>Invalid Email Address</span>
                                                                }
                                                            </Grid>
                                                        </>
                                                    }
                                                </Grid>
                                            </div>
                                        </Grid>
                                        <Grid item xs={3} sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between",
                                            alignItems: "flex-end"
                                        }}>
                                            <Grid container direction="row" spacing={2} sx={{
                                                justifyContent: "flex-end",
                                                alignItems: "baseline",
                                                marginTop: "5px"
                                            }}>
                                                {currentPurchase?.product_enable_member_changes_group === 1 && showChangeGroup && canManageGroupChange && !hideChangeGroupByResale &&
                                                    <Tooltip title={'Change Group'} placement='top'>
                                                        <Button
                                                            color='primary'
                                                            variant='contained'
                                                            size='small'
                                                            sx={{margin: '4px', padding: '4px', minWidth: '24px'}}
                                                            onClick={() => handleChangeGroupClick()}>
                                                            <MoveDown/>
                                                        </Button>
                                                    </Tooltip>
                                                }
                                                {transferMembershipEnabled && currentPurchase?.product_enable_transfer_membership === 1 && showChangeJob && canTransferMembership &&
                                                    <Tooltip title={'Transfer Membership'} placement={'top'}>
                                                        <Button
                                                            color='primary'
                                                            variant='contained'
                                                            size='small'
                                                            sx={{margin: '4px', padding: '4px', minWidth: '24px'}}
                                                            onClick={() => setOpenTransferMembershipModal(true)}
                                                        >
                                                            <LowPriority/>
                                                        </Button>
                                                    </Tooltip>
                                                }
                                                {transferMembershipEnabled && currentPurchase && showChangeJob && canCancelPurchase &&
                                                    <Tooltip title={'Cancel Purchase'} placement={'top'}>
                                                        <Button
                                                            color='primary'
                                                            variant='contained'
                                                            size="small"
                                                            sx={{
                                                                margin: '4px 0px 4px 4px',
                                                                padding: '4px',
                                                                minWidth: '24px'
                                                            }}
                                                            onClick={() => setOpenCancelPurchaseModal(true)}
                                                        >
                                                            <PersonRemove/>
                                                        </Button>
                                                    </Tooltip>
                                                }
                                            </Grid>
                                            <div style={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                                alignItems: "flex-end"
                                            }}>
                                                <Typography variant='body2' color='site.main'
                                                            className={classes.flexVertical}>
                                                    <a target='_blank' rel="noreferrer"
                                                       href={personDetails.person_linkedin_url}
                                                       style={{display: "flex"}}>
                                                        <LinkedIn sx={{color: "icon.linkedin", fontSize: "44px"}}/>
                                                    </a>
                                                </Typography>
                                                <Typography variant='body2' color='site.main'>
                                                    <a target='_blank' rel="noreferrer"
                                                       href={`${ERP_BASE_URL}/#/contacts/persons/${personDetails.person_id}`}
                                                       style={{display: "flex"}}>
                                                        <img alt='' src={logo} className='logo-link'></img>
                                                    </a>
                                                </Typography>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
                <Grid item xs={12}>
                    <Box mb={2}>
                        <Box className={classes.panel}>
                            <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                <Typography variant='h1' component='h5' sx={{fontSize: "18px", fontWeight: "500"}}>
                                    Personal Details
                                </Typography>
                                <Box sx={{display: "flex", justifyContent: "flex-end", minWidth: "100px"}}>
                                    <ChevronLeft
                                        sx={{cursor: "pointer"}}
                                        className={isOpen ? "showUP" : "showDown"}
                                        onClick={() => setIsOpen(!isOpen)}
                                    />
                                </Box>
                            </Box>
                        </Box>
                        {isOpen && (
                            <Box className={classes.panel}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <table className={classes.personTable} style={{width: "100%"}}>
                                                    <tbody>
                                                    <tr>
                                                        <td>
                                                            <Typography variant='h1' component='h5'
                                                                        sx={{fontSize: "14px", fontWeight: "bold"}}>
                                                                Gender
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography sx={{
                                                                fontSize: "14px",
                                                                margin: 0,
                                                                textTransform: "capitalize"
                                                            }}>
                                                                {personDetails.person_gender}
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    {!isNetworkDirector && (
                                                        <>
                                                            <tr>
                                                                <td>
                                                                    <Typography
                                                                        variant='h1'
                                                                        component='h5'
                                                                        sx={{fontSize: "14px", fontWeight: "bold"}}
                                                                    >
                                                                        Challenges
                                                                    </Typography>
                                                                </td>
                                                                <td>
                                                                    <div
                                                                        style={{display: "flex", alignItems: "center"}}>
                                                                        <TextField
                                                                            type='text'
                                                                            id='person_challenges'
                                                                            label=''
                                                                            variant='outlined'
                                                                            size='small'
                                                                            style={{width: "90%"}}
                                                                            value={personChallenges}
                                                                            onChange={(e) => {
                                                                                setPersonChallenges(e.target.value);
                                                                            }}
                                                                        ></TextField>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <Typography
                                                                        variant='h1'
                                                                        component='h5'
                                                                        sx={{fontSize: "14px", fontWeight: "bold"}}
                                                                    >
                                                                        Food Considerations
                                                                    </Typography>
                                                                </td>
                                                                <td>
                                                                    <FormControl
                                                                        sx={{
                                                                            minWidth: 120,
                                                                            width: "49%",
                                                                            marginRight: "1%"
                                                                        }}
                                                                        size='small'
                                                                    >
                                                                        <InputLabel
                                                                            id='person_food_considerations_1'>Type</InputLabel>
                                                                        <Select
                                                                            labelId='person_food_considerations_1'
                                                                            id='person_food_considerations_1'
                                                                            value={personFoodConsiderations1 == "" ? foodConsiderations.type1_food.find(item => item.id == 17).id : personFoodConsiderations1}
                                                                            label='Type'
                                                                            onChange={(e) => {
                                                                                setPersonFoodConsiderations1(e.target.value);
                                                                            }}
                                                                        >
                                                                            <MenuItem value=''>-- Select
                                                                                Type--</MenuItem>
                                                                            {foodConsiderations &&
                                                                                foodConsiderations.type1_food.map((item) => (
                                                                                    <MenuItem key={item.id}
                                                                                              value={item.id}>
                                                                                        {item.title}
                                                                                    </MenuItem>
                                                                                ))}
                                                                        </Select>
                                                                    </FormControl>
                                                                    <FormControl sx={{minWidth: 120, width: "50%"}}
                                                                                 size='small'>
                                                                        <InputLabel
                                                                            id='person_food_considerations_2'>Allergy</InputLabel>
                                                                        <Select
                                                                            labelId='person_food_considerations_2'
                                                                            id='person_food_considerations_2'
                                                                            multiple
                                                                            value={!personFoodConsiderations2.length ? [18] : personFoodConsiderations2}
                                                                            onChange={(e) => {
                                                                                setPersonFoodConsiderations2(e.target.value);
                                                                                if (e.target.value.includes(18)) {
                                                                                    setPersonFoodConsiderations2((prevArray) => prevArray.filter(item => item !== 18));
                                                                                } else if (!e.target.value.length) {
                                                                                    setPersonFoodConsiderations2([18]);
                                                                                }

                                                                                if (!e.target.value.includes(16)) {
                                                                                    setPersonFoodConsiderationsOther("");
                                                                                }
                                                                            }}
                                                                            input={<OutlinedInput label='Name'/>}
                                                                        >
                                                                            {foodConsiderations &&
                                                                                foodConsiderations.type2_food.map((item) => (
                                                                                    <MenuItem key={item.id}
                                                                                              value={item.id}>
                                                                                        {item.title}
                                                                                    </MenuItem>
                                                                                ))}
                                                                        </Select>
                                                                    </FormControl>
                                                                    {personFoodConsiderations2.includes(16) && (
                                                                        <TextField
                                                                            type='text'
                                                                            id='food_consideration_other'
                                                                            name='food_consideration_other'
                                                                            label='Other'
                                                                            variant='outlined'
                                                                            size='large'
                                                                            style={{marginTop: "10px", width: "100%"}}
                                                                            value={personFoodConsiderationsOther}
                                                                            onChange={(e) => {
                                                                                setPersonFoodConsiderationsOther(e.target.value);
                                                                            }}
                                                                        ></TextField>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        </>
                                                    )}
                                                    <tr>
                                                        <td>
                                                            <Typography variant='h1' component='h5'
                                                                        sx={{fontSize: "14px", fontWeight: "bold"}}>
                                                                Special Conditions
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography sx={{fontSize: "14px", margin: 0}}>
                                                                {personDetails.person_special_conditions}
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <Typography variant='h1' component='h5'
                                                                        sx={{fontSize: "14px", fontWeight: "bold"}}>
                                                                Mobile Number
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography sx={{fontSize: "14px", margin: 0}}>
                                                                <a href={`callto:${personDetails.person_mobile_number}`}>
                                                                    {personDetails.person_mobile_number}
                                                                </a>
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <Typography variant='h1' component='h5'
                                                                        sx={{fontSize: "14px", fontWeight: "bold"}}>
                                                                Connections Count
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography sx={{fontSize: "14px", margin: 0}}>
                                                                {personDetails.person_li_connection_count}
                                                            </Typography>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td>
                                                            <Typography variant='h1' component='h5'
                                                                        sx={{fontSize: "14px", fontWeight: "bold"}}>
                                                                Never Contact

                                                                <PersonConfigurationHistoryTooltip
                                                                    personDetails={personDetails}
                                                                    fieldName="person_never_contact_history_note"
                                                                />
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography sx={{fontSize: "14px", margin: 0}}>
                                                                <input
                                                                    name='person_never_contact'
                                                                    type='checkbox'
                                                                    checked={neverContact}
                                                                    onChange={handleInputChange}
                                                                    className={classes.checkbox}
                                                                    disabled={isNetworkDirector}
                                                                />
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <Typography variant='h1' component='h5'
                                                                        sx={{fontSize: "14px", fontWeight: "bold"}}>
                                                                Never SMS

                                                                <PersonConfigurationHistoryTooltip
                                                                    personDetails={personDetails}
                                                                    fieldName="person_preferences_never_text_history_note"
                                                                />
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography sx={{fontSize: "14px", margin: 0}}>
                                                                <input
                                                                    name='person_preferences_never_text'
                                                                    type='checkbox'
                                                                    checked={neverSms}
                                                                    onChange={handleInputChange}
                                                                    className={classes.checkbox}
                                                                    disabled={isNetworkDirector}
                                                                />
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <Typography variant='h1' component='h5'
                                                                        sx={{fontSize: "14px", fontWeight: "bold"}}>
                                                                Limit Calls

                                                                <PersonConfigurationHistoryTooltip
                                                                    personDetails={personDetails}
                                                                    fieldName="person_preferences_limit_calls_history_note"
                                                                />
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography sx={{fontSize: "14px", margin: 0}}>
                                                                <input
                                                                    name='person_preferences_limit_calls'
                                                                    type='checkbox'
                                                                    checked={limitCalls}
                                                                    onChange={handleInputChange}
                                                                    className={classes.checkbox}
                                                                    disabled={isNetworkDirector}
                                                                />
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <Typography variant='h1' component='h5'
                                                                        sx={{fontSize: "14px", fontWeight: "bold"}}>
                                                                Limit Emails
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography sx={{fontSize: "14px", margin: 0}}>
                                                                <input
                                                                    name='person_preferences_limit_emails'
                                                                    type='checkbox'
                                                                    checked={limitEmails}
                                                                    onChange={handleInputChange}
                                                                    className={classes.checkbox}
                                                                    disabled={true}
                                                                />
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <Typography variant='h1' component='h5'
                                                                        sx={{fontSize: "14px", fontWeight: "bold"}}>
                                                                Pause Sendouts

                                                                <PersonConfigurationHistoryTooltip
                                                                    personDetails={personDetails}
                                                                    fieldName="person_preferences_pause_sendouts_history_note"
                                                                />
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography sx={{fontSize: "14px", margin: 0}}>
                                                                <input
                                                                    name='person_preferences_pause_sendouts'
                                                                    type='checkbox'
                                                                    checked={pauseSendouts}
                                                                    onChange={handleInputChange}
                                                                    className={classes.checkbox}
                                                                />
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <Typography variant='h1' component='h5'
                                                                        sx={{fontSize: "14px", fontWeight: "bold"}}>
                                                                CC Email
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography sx={{fontSize: "14px", margin: 0}}>
                                                                <a href={`mailto:${personDetails.person_cc_email}`}>
                                                                    {personDetails.person_cc_email}
                                                                </a>
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <Typography variant='h1' component='h5'
                                                                        sx={{fontSize: "14px", fontWeight: "bold"}}>
                                                                LinkedIn MemberID
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography sx={{fontSize: "14px", margin: 0}}>
                                                                {personDetails.person_linkedin_member_id}
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <Typography variant='h1' component='h5'
                                                                        sx={{fontSize: "14px", fontWeight: "bold"}}>
                                                                Lead Source
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography sx={{fontSize: "14px", margin: 0}}>
                                                                {personDetails.lead_source}
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <Typography variant='h1' component='h5'
                                                                        sx={{fontSize: "14px", fontWeight: "bold"}}>
                                                                Last Scrape Time
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography sx={{fontSize: "14px", margin: 0}}>
                                                                {personDetails.person_last_scrape_time}
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <Typography variant="h1" component="h5"
                                                                        sx={{fontSize: '14px', fontWeight: 'bold'}}>
                                                                Tags
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <TagHook tags={props.Tags} setValue={handleTags}
                                                                     selectedTags={personDetails.tags} edit={false}/>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={2}>
                                                            <LoadingButton
                                                                loading={updateContactLoading}
                                                                color='primary'
                                                                variant='contained'
                                                                sx={{
                                                                    display: "block",
                                                                    width: "100%",
                                                                    marginTop: "10px"
                                                                }}
                                                                onClick={saveInfo}
                                                            >
                                                                Save
                                                            </LoadingButton>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Box>
                        )}
                    </Box>
                </Grid>
                {!attendeeDetails ? (
                    <Grid item xs={12} sx={{display: "flex", justifyContent: "center"}}>
                        <CircularProgress/>
                    </Grid>
                ) : (
                    <>
                        <Grid item xs={12}>
                            <div className={classes.flex}>
                                {attendeeDetails &&
                                    eventOverview.length > 0 &&
                                    eventOverview.map((item, index) => {
                                        const color = getStatusClass(item);
                                        return (
                                            <Tooltip
                                                key={index}
                                                title={
                                                    <React.Fragment>
                                                        <div>{item.event_name}</div>
                                                        <div>Date: {moment(item.event_start).format("DD/MM/YYYY HH:mm")}</div>
                                                        <div>
                                                            {item.event_has_happened ? (
                                                                <>
                                                                    {item.rating_nps ? <div>NPS
                                                                        Rating: {item.rating_nps}</div> : <></>}{" "}
                                                                    {item.rating_overall ? <div>Overall
                                                                        Rating: {item.rating_overall}</div> : <></>}{" "}
                                                                </>
                                                            ) : (
                                                                <></>
                                                            )}
                                                        </div>
                                                    </React.Fragment>
                                                }
                                            >
                                                <div className={classes[color]}></div>
                                            </Tooltip>
                                        );
                                    })}
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <div className={classes.sendout}>
                                <div style={{display: "flex", alignItems: "center"}}>
                                    <Typography component='span' style={{marginRight: "10px"}}>
                                        <b>Sendout Overview</b>
                                    </Typography>
                                    <div className={classes.flex}>
                                        {attendeeDetails &&
                                        attendeeDetails.outbound_overview &&
                                        attendeeDetails.outbound_overview.event_calendar_ph_email.length ? (
                                            <OutboundOverview
                                                item={attendeeDetails.outbound_overview.event_calendar_ph_email}
                                                name='Calendar Placeholder Invitation'
                                                classes={classes}
                                            />
                                        ) : (
                                            <OutboundOverview name='Calendar Placeholder Invitation' classes={classes}/>
                                        )}
                                        {attendeeDetails &&
                                        attendeeDetails.outbound_overview &&
                                        attendeeDetails.outbound_overview.event_calendar_email.length ? (
                                            <OutboundOverview
                                                item={attendeeDetails.outbound_overview.event_calendar_email}
                                                name='Calendar Invitation'
                                                classes={classes}
                                            />
                                        ) : (
                                            <OutboundOverview name='Calendar Invitation' classes={classes}/>
                                        )}
                                        {attendeeDetails &&
                                        attendeeDetails.outbound_overview &&
                                        attendeeDetails.outbound_overview.event_invitation_email.length ? (
                                            <OutboundOverview
                                                item={attendeeDetails.outbound_overview.event_invitation_email}
                                                name='Invitation Email'
                                                classes={classes}
                                            />
                                        ) : (
                                            <OutboundOverview name='Invitation Email' classes={classes}/>
                                        )}
                                        {attendeeDetails &&
                                        attendeeDetails.outbound_overview &&
                                        attendeeDetails.outbound_overview.event_reminder_email.length ? (
                                            <OutboundOverview
                                                item={attendeeDetails.outbound_overview.event_reminder_email}
                                                name='Reminder Email'
                                                classes={classes}
                                            />
                                        ) : (
                                            <OutboundOverview name='Reminder Email' classes={classes}/>
                                        )}
                                        {attendeeDetails &&
                                        attendeeDetails.outbound_overview &&
                                        attendeeDetails.outbound_overview.event_reminder_sms.length ? (
                                            <OutboundOverview
                                                item={attendeeDetails.outbound_overview.event_reminder_sms}
                                                name='Reminder SMS'
                                                classes={classes}
                                            />
                                        ) : (
                                            <OutboundOverview name='Reminder SMS' classes={classes}/>
                                        )}
                                        {attendeeDetails &&
                                        attendeeDetails.outbound_overview &&
                                        attendeeDetails.outbound_overview.event_summary_email.length ? (
                                            <OutboundOverview
                                                item={attendeeDetails.outbound_overview.event_summary_email}
                                                name='Summary Email'
                                                classes={classes}
                                            />
                                        ) : (
                                            <OutboundOverview name='Summary Email' classes={classes}/>
                                        )}
                                    </div>
                                </div>
                                {!isNetworkDirector && (
                                    <div style={{marginLeft: "0px"}}>
                                        <select style={{minWidth: "180px"}} className={classes.selectBox}
                                                onChange={handleSendoutEmail}>
                                            <option value=''>-- Select --</option>
                                            {sendOutEmails.map((email, index) => {
                                                return (
                                                    <option key={index} value={email.value}>
                                                        {email.title}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                )}
                                {!isNetworkDirector && !personDetails.special_case_status && (
                                    <div style={{display: "flex", justifyContent: "space-between"}}>
                                        <ButtonGroup size='small' variant='contained'
                                                     aria-label='outlined primary button group'>
                                            <Button style={{textTransform: "capitalize"}}
                                                    onClick={() => setOpenCaseModal(true)}>
                                                Pause
                                            </Button>
                                            <Button style={{textTransform: "capitalize"}}
                                                    onClick={() => setEventModalOpen(true)}>
                                                Special Case
                                            </Button>
                                        </ButtonGroup>
                                    </div>
                                )}
                                {!isNetworkDirector && personDetails.special_case_status && (
                                    <div style={{display: "flex", justifyContent: "space-between"}}>
                                        <Button
                                            style={{
                                                textTransform: "capitalize",
                                                backgroundColor: "purple",
                                                color: "#fff"
                                            }}
                                            onClick={(e) => handleTabChange(e, "special case")}
                                        >
                                            {personDetails.special_case_status.toLowerCase() === "pause" ? "Paused" : "Ongoing"}
                                        </Button>
                                    </div>
                                )}
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <div className={classes.sendout}>
                                <Typography component='span' style={{marginRight: "10px"}}>
                                    <b>Attending Status</b>
                                </Typography>

                                <div className={classes.flexCenter}>
                                    {
                                        (participantDetails.attendance_verified === 1 &&
                                            (user.user_details.member_service_agent ||
                                                user.user_details.resale_sales_rep)) &&
                                        <Button
                                            className={classes[""]}
                                            color='inherit'
                                            variant='contained'
                                            sx={{marginRight: "10px"}}
                                            onClick={() => attendanceVerificationUpdate(false)}
                                        >
                                            Disapprove Attendance
                                        </Button>
                                    }

                                    {attendingStatus.map((item, index) => {
                                        const selected =
                                            participantDetails?.answer?.value === item.value
                                                ? item.value
                                                : "";
                                        return (
                                            <Button
                                                disabled={eventInfo.event_attendance_done !== false || isNetworkDirector}
                                                className={classes[selected]}
                                                color='inherit'
                                                variant='contained'
                                                key={index + 200}
                                                sx={{marginRight: "10px"}}
                                                onClick={() => attendanceStatusUpdate(item)}
                                            >
                                                {
                                                    participantDetails.attendance_verified === 1 && selected !== "" &&
                                                    <Check/>
                                                }
                                                {item.title}
                                            </Button>
                                        );
                                    })}
                                </div>
                            </div>
                        </Grid>
                    </>
                )}
                {personOpenOpportunity && !isNetworkDirector && !isEmpty(personOpenOpportunity) && (
                    <Grid item xs={12}>
                        <Card className={classes.card}>
                            <CardContent className={classes.cardContent}>
                                <NextPlannedAction
                                    opportunity={personOpenOpportunity}
                                    person={person}
                                    opportunityDetails={opportunity}
                                    events={events}
                                    plannedAction={plannedAction}
                                    opportunityLoading={opportunityLoading}
                                    getCalendarLoading={getCalendarLoading}
                                />

                                <div style={{
                                    borderTop: "1px solid #c8c8c8",
                                    padding: "10px 0",
                                    margin: "10px 0 0"
                                }}></div>

                                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                    <div style={{marginRight: "10px", display: "flex", flexDirection: "column"}}>
										<span>
											<b>Current Open Opportunity:</b>{" "}
                                            {personOpenOpportunity && personOpenOpportunity.opportunity_id ? (
                                                <a
                                                    href={`${window.location.origin}/opportunities/id/${
                                                        personOpenOpportunity ? personOpenOpportunity.opportunity_id : undefined
                                                    }`}
                                                    target='_blank'
                                                >
                                                    {personOpenOpportunity && personOpenOpportunity.opportunity_id}
                                                </a>
                                            ) : (
                                                "None"
                                            )}
										</span>
                                        <span
                                            style={{fontSize: "15px"}}>({personOpenOpportunity && personOpenOpportunity.sales_rep_name})</span>
                                    </div>
                                    <div style={{display: "flex", alignItems: "center"}}>
                                        <Typography component='span' style={{marginRight: "10px"}}>
                                            <b>Pipeline Stage:</b>
                                        </Typography>
                                        <FormControl size='small' sx={{minWidth: "200px"}}>
                                            <InputLabel id='person_pipeline_stage'>Pipeline Stage</InputLabel>
                                            <Select
                                                fullWidth
                                                labelId='person_pipeline_stage'
                                                id='person_pipeline_stage'
                                                value={personPielineStage}
                                                onChange={(e) => {
                                                    const selected_stage = personOpenOpportunity.pipeline_stages.filter(
                                                        (item) => item.pipeline_stage_id === e.target.value
                                                    )[0];
                                                    const current_stage = personOpenOpportunity.pipeline_stages.filter(
                                                        (item) => item.pipeline_stage_id === personPielineStage
                                                    )[0];
                                                    Swal.fire({
                                                        customClass: {
                                                            title: "custom-swal-title",
                                                            confirmButton: "custom-swal-confirm",
                                                        },
                                                        title: "You are going to change the stage of the opportunity",
                                                        html: `${current_stage.pipeline_stage_title} &#8594 ${selected_stage.pipeline_stage_title}`,
                                                        width: "600px",
                                                        showCancelButton: true,
                                                        confirmButtonColor: "#e0e0e0",
                                                        cancelButtonColor: "#d33",
                                                        confirmButtonText: "Confirm",
                                                        cancelButtonText: "Cancel",
                                                    }).then((result) => {
                                                        if (result.isConfirmed) {
                                                            setPersonPielineStage(e.target.value);
                                                            props.updatePersonStage({
                                                                person_id: person.person_id,
                                                                opportunityId: personOpenOpportunity.opportunity_id,
                                                                stageId: e.target.value,
                                                            });
                                                        }
                                                    });
                                                }}
                                                input={<OutlinedInput label='Pipeline Stage'/>}
                                            >
                                                {personPielineStages.map((item) => (
                                                    <MenuItem key={item.pipeline_stage_id}
                                                              value={item.pipeline_stage_id}>
                                                        {item.pipeline_stage_title}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    </Grid>
                )}
                {!isNetworkDirector && (
                    <Grid item xs={12}>
                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMore/>} aria-controls='panel5a-content'
                                              id='panel5a-header'>
                                Follow Ups
                            </AccordionSummary>
                            <AccordionDetails sx={{background: "#ffffff"}}>
                                <FollowUp person={person}
                                          jobEmail={[primaryJob]} hideTitle={true}/>
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                )}
                <Grid item xs={12}>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMore/>}
                            aria-controls='panel2a-content'
                            id='panel2a-header'
                            className={classes.accordionSummary}
                        >
                            <div style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "100%",
                                paddingRight: "20px"
                            }}>
                                <Typography variant='h1' component='h5'
                                            sx={{fontSize: "18px", fontWeight: "500", marginBottom: "10px"}}>
                                    Jobs
                                </Typography>
                                {
                                    eventDetails?.user_id === user.user_details.user_id &&
                                    <EditIcon
                                        sx={{color: "icon.main", fontSize: '20px', cursor: 'pointer', zIndex: '99999'}}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setEditJobEmail(true)
                                        }}/>
                                }
                            </div>
                            {
                                primaryJob &&
                                <PersonJobOverview job={primaryJob} companies={jobs.related_objects.companies}
                                                   editJobEmail={editJobEmail}
                                                   setEditJobEmail={setEditJobEmail}
                                                   person={personObj}
                                                   event={eventDetails}/>
                            }
                        </AccordionSummary>
                        <AccordionDetails>
                            {jobs &&
                                jobs.main
                                    .filter((item) => !item.job_is_primary)
                                    .map((job, _index) => (
                                        <PersonJobOverview job={job} companies={jobs.related_objects.companies}/>))}
                        </AccordionDetails>
                    </Accordion>
                </Grid>
                <Grid item xs={12}>
                    <ParticipantPurchases classes={classes} personPurchases={personPurchases}/>
                </Grid>
                <Grid item xs={12}>
                    <Accordion>
                        <AccordionSummary expandIcon={<ExpandMore/>} aria-controls='panel3a-content'
                                          id='panel3a-header'>
                            <Typography variant='h1' component='h5' sx={{fontSize: "18px", fontWeight: "500"}}>
                                Opportunities
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {personOpportunities &&
                                personOpportunities.map((opportunity, index) => {
                                    return (
                                        <Grid
                                            key={index}
                                            container
                                            spacing={2}
                                            sx={{padding: "10px 0", borderTop: "1px solid #c2c2c2", marginTop: 0}}
                                        >
                                            <Grid item xs={6} sx={{paddingTop: "0 !important"}}>
                                                <div style={{display: "flex", flexDirection: "column"}}>
                                                    <Typography style={{fontSize: "13px"}} gutterBottom variant='h6'
                                                                component='div'>
                                                        {opportunity.product_name}
                                                    </Typography>
                                                    <Typography
                                                        style={{flexGrow: "1", fontSize: "11px"}}
                                                        gutterBottom
                                                        variant='span'
                                                        component='span'
                                                    >
                                                        {opportunity.product_type_name}
                                                    </Typography>
                                                </div>
                                            </Grid>
                                            <Grid item xs={2} sx={{paddingTop: "0 !important"}}>
                                                <Typography style={{fontSize: "13px"}} gutterBottom variant='h6'
                                                            component='div'>
                                                    {opportunity.opportunity_status}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={2} sx={{paddingTop: "0 !important"}}>
                                                <Typography
                                                    style={{padding: "0 10px 0 0", fontSize: "13px"}}
                                                    gutterBottom
                                                    className={classes.typography}
                                                    variant='span'
                                                    component='span'
                                                >
                                                    {opportunity.opportunity_type}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={2} sx={{paddingTop: "0 !important"}}>
                                                <Typography
                                                    style={{padding: "0 10px 0 0", fontSize: "13px"}}
                                                    gutterBottom
                                                    className={classes.typography}
                                                    variant='span'
                                                    component='span'
                                                >
                                                    {moment(opportunity.opportunity_creation_time).format("DD/MM/YYYY hh:mm")}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    );
                                })}
                        </AccordionDetails>
                    </Accordion>
                </Grid>
                <Grid item xs={12}>
                    <Accordion expanded={expanded === "panel4"} onChange={handleChange("panel4")}>
                        <AccordionSummary expandIcon={<ExpandMore/>} aria-controls='panel4a-content'
                                          id='panel4a-header'>
                            <Typography
                                variant='h1'
                                component='h5'
                                sx={{display: "flex", alignItems: "center", fontSize: "18px", fontWeight: "500"}}
                            >
                                History <span
                                className={classes.historyCount}>{personHistory && personHistory.length}</span>
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{background: "#efefef"}}>
                            <PersonHistory person={personObj} isNetworkDirector={isNetworkDirector}/>
                        </AccordionDetails>
                    </Accordion>
                </Grid>
            </Grid>
            <CaseOngoingModal
                open={eventModalOpen}
                handleClose={() => setEventModalOpen(false)}
                startDate={action.opportunity_action_due_time}
                opportunity={personOpenOpportunity}
                action={action}
                person={person}
                editEvent={action.opportunity_action_due_time ? true : false}
                event_id={eventInfo.event_id}
                participant_id={person.potential_participant_id}
                query={overviewQuery}
                columns={personColumns}
                toggleSpecialCaseTab={toggleSpecialCaseTab}
            />
            <CasePauseModal
                open={openCaseModal}
                handleClose={() => setOpenCaseModal(false)}
                person={person}
                event_id={eventInfo.event_id}
                participant_id={person.potential_participant_id}
                query={overviewQuery}
                columns={personColumns}
                toggleSpecialCaseTab={toggleSpecialCaseTab}
            />
            <TransferMembershipModal
                open={openTransferMembershipModal}
                handleClose={handleTransferMembershipClose}
                personId={person.person_id}
                personPurchases={personPurchases}
                transferLater={false}
                eventOverview={eventOverview}
                classes={classes}/>
            <CancelPurchaseModal
                open={openCancelPurchaseModal}
                handleClose={handleCancelPurchaseClose}
                personId={person.person_id}/>
        </>
    );
};

const mapStateToProps = (state) => ({
    errorMessage: eventsOverviewSelectors.errorMessage(state),
    personPurchases: eventsOverviewSelectors.personPurchases(state),
    personOpportunities: eventsOverviewSelectors.personOpportunities(state),
    participantDetails: eventsOverviewSelectors.participantDetails(state),
    contactDetails: ContactsSelectors.contactDetails(state),
    foodConsiderations: ContactsSelectors.foodConsiderations(state),
    jobs: opportunitySelectors.jobs(state),
    personHistory: eventsOverviewSelectors.personHistory(state),
    personOpenOpportunity: eventsOverviewSelectors.personOpenOpportunity(state),
    events: opportunitySelectors.events(state),
    opportunity: opportunitySelectors.opportunity(state),
    plannedAction: opportunitySelectors.plannedActionResponse(state),
    opportunityLoading: opportunitySelectors.opportunity_loading(state),
    getCalendarLoading: opportunitySelectors.getCalendar_loading(state),
    Tags: ContactsSelectors.Tags(state),
    updateContactLoading: ContactsSelectors.updateContactLoading(state),
    canManageGroupChange: accountSelectors.canManageGroupChange(state),
    canCancelPurchase: accountSelectors.canCancelPurchase(state),
    canTransferMembership: accountSelectors.canTransferMembership(state),
    transferMembershipEnabled: adminSelectors.transferMembershipEnabled(state),
    updateJobPhone_loading: opportunitySelectors.updateJobPhone_loading(state),
    updatePrimaryJobEmailError: opportunitySelectors.updatePrimaryJobEmail_error(state),
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            updateAttendanceStatus: eventsOverviewActions.updateAttendanceStatus,
            updateSendoutEmail: eventsOverviewActions.updateSendoutEmail,
            updatePersonStage: eventsOverviewActions.updatePersonStage,
            getPersonPurchases: eventsOverviewActions.getPersonPurchases,
            getPersonOpenOpportunity: eventsOverviewActions.getPersonOpenOpportunity,
            getPersonOpportunities: eventsOverviewActions.getPersonOpportunities,
            getParticipantDetails: eventsOverviewActions.getParticipantDetails,
            getContactDetails: contactsActions.getContactDetails,
            getFoodConsiderations: contactsActions.getFoodConsiderations,
            getJobs: opportunityActions.getJobs,
            updateContact: contactsActions.updateContact,
            getOpportunityDetails: opportunityActions.getOpportunityDetails,
            updateAttendanceVerification: eventsOverviewActions.updateAttendanceVerification,
            updateJobPhone: opportunityActions.updateJobPhone,
            updatePrimaryJobEmail: opportunityActions.updatePrimaryJobEmail,
        },
        dispatch
    );

function WithNavigate(props) {
    let params = useParams();
    let navigate = useNavigate();
    return <PersonOverviewTab {...props} params={params} navigate={navigate}/>;
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(useStyles)(WithNavigate));
